(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function toast(t) {
    var el = $('#toast'); if (!el) return;
    el.textContent = t; el.hidden = false;
    clearTimeout(toast.t); toast.t = setTimeout(function () { el.hidden = true; }, 2000);
  }

  function updateCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { $$('[data-cart-count]').forEach(function (n) { n.textContent = c.item_count; }); })
      .catch(function () {});
  }

  function addToCart(form) {
    var data = new FormData(form);
    data.delete('return_to');
    return fetch(window.APA.cartAddUrl + '.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { toast(window.APA.t.added); updateCount(); })
      .catch(function (e) { toast((e && e.description) || window.APA.t.addError); });
  }

  // "+" nos cartões de produto
  $$('form[data-ajax-add]').forEach(function (f) {
    f.addEventListener('submit', function (e) { e.preventDefault(); addToCart(f); });
  });

  // Página de produto: troca de opção, galeria e "Adicionar ao carrinho"
  var form = $('[data-product-form]');
  if (form) {
    var sel = $('[data-variant-select]', form);
    if (sel) sel.addEventListener('change', function () {
      var o = sel.options[sel.selectedIndex];
      var p = $('[data-price-box] [data-price]'); if (p) p.textContent = o.dataset.price;
      var c = $('[data-price-box] [data-compare]'); if (c) { c.textContent = o.dataset.compare; c.hidden = !o.dataset.compare; }
    });
    var add = $('[data-add-cart]', form);
    if (add) add.addEventListener('click', function () { addToCart(form); });
  }
  var mainImg = $('#pdp-main-img');
  $$('.g-thumb').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!mainImg) return;
      mainImg.removeAttribute('srcset'); mainImg.src = b.dataset.full;
      $$('.g-thumb').forEach(function (x) { x.setAttribute('aria-current', x === b); });
    });
  });

  // Coleção: ordenar
  var sort = $('[data-sort]');
  if (sort) sort.addEventListener('change', function () {
    var u = new URL(location.href); u.searchParams.set('sort_by', sort.value); location.href = u.toString();
  });

  // Carrinho: quantidades, desistir e downsell
  var cartForm = $('#cart-form');
  if (cartForm) {
    $$('[data-qty]', cartForm).forEach(function (i) {
      i.addEventListener('change', function () { var u = $('[data-update]', cartForm); if (u) u.hidden = false; });
    });
    var stopArea = $('[data-stop-area]'), ds = $('[data-downsell]'), conf = $('[data-confirm]');
    var cupom = new URL(location.href).searchParams.get('cupom');
    if (cupom) {
      var n = $('[data-cupom-note]'); if (n) { $('[data-cupom-code]', n).textContent = cupom; n.hidden = false; }
      try { sessionStorage.setItem('apa-cupom', cupom); } catch (e) {}
      toast(window.APA.t.couponApplied.replace('__CODE__', cupom));
    }
    var jaTemCupom = !!cupom;
    try { jaTemCupom = jaTemCupom || !!sessionStorage.getItem('apa-cupom'); } catch (e) {}
    var ask = $('[data-ask-stop]');
    if (ask) ask.addEventListener('click', function () {
      stopArea.hidden = true;
      if (!jaTemCupom && ds) ds.hidden = false; else if (conf) conf.hidden = false;
    });
    $$('[data-keep]').forEach(function (b) { b.addEventListener('click', function () { conf.hidden = true; stopArea.hidden = false; }); });
    $$('[data-stop]').forEach(function (b) {
      b.addEventListener('click', function () {
        b.disabled = true;
        fetch(window.APA.cartClearUrl + '.js', { method: 'POST', headers: { Accept: 'application/json' } })
          .then(function () { try { sessionStorage.removeItem('apa-cupom'); } catch (e) {} location.href = window.APA.cartUrl; })
          .catch(function () { b.disabled = false; toast(window.APA.t.clearError); });
      });
    });
  }

  // Login: abre "Esqueci minha senha"
  $$('[data-show-recover]').forEach(function (a) {
    a.addEventListener('click', function () { setTimeout(function () { var i = $('#rc-email'); if (i) i.focus(); }, 50); });
  });
})();

(function(){
  var box=document.querySelector('[data-recs]');
  if(!box||!window.fetch) return;
  fetch(box.getAttribute('data-url')).then(function(r){return r.text()}).then(function(html){
    var tmp=document.createElement('div'); tmp.innerHTML=html;
    var inner=tmp.querySelector('[data-recs]');
    if(inner&&inner.innerHTML.trim()) box.innerHTML=inner.innerHTML;
  }).catch(function(){});
})();
